
namespace TabAurous.Common {
    import fld = Stock.StockItemRow.Fields;
    @Serenity.Decorators.registerClass()
    export class StockSelectGrid extends _Ext.GridBase<Stock.StockItemRow, any> {
         
        protected getColumnsKey() { return 'Stock.StockItem'; } 
        protected getIdProperty() { return Stock.StockItemRow.idProperty; }
        protected getLocalTextPrefix() { return Stock.StockItemRow.localTextPrefix; }
        protected getService() { return Stock.StockItemService.baseUrl; }
        protected getInitialTitle() { return null; };
          
        private colums: Slick.Column[]
        radioElement: JQuery;
        radionbutton: JQuery;

        protected getColumns() { 

            var _this = this;
            var columns = super.getColumns.call(this);
            this.colums = columns;  
            return columns;
        };

        constructor(container: JQuery, options: any) {
            super(container, options); 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });

            this.slickGrid.setOptions({ rowHeight: 30 });
            this.element.height(650);
            this.addQuickFilter({
                type: Retail.TempEditor,
                title: "",
                separator: false,
                field: "ItemTypeId"
            });

            var hasbom = options.GridFilters.HasBom;
            if (hasbom != undefined && hasbom)
                (this.view.params as TransactionRequest).HasBom = hasbom;


            var studded = options.GridFilters.Studded;
            if (studded != undefined && studded != null)
                (this.view.params as TransactionRequest).Studded = studded;

            var metalcolorid = options.GridFilters.MetalColorId;
            if (metalcolorid != undefined && metalcolorid)
                (this.view.params as TransactionRequest).MetalColorId = metalcolorid;


            var karatid = options.GridFilters.KaratId;
            if (karatid != undefined && karatid != null)
                (this.view.params as TransactionRequest).KaratId = karatid;

            var deptid = options.GridFilters.DepartmentId;
            if (deptid != undefined && deptid != null)
                (this.view.params as TransactionRequest).DepartmentId = deptid;

            var filteritem = options.GridFilters.FilterItems;
            let propertyName: string = "s-TempEditor s-Retail-TempEditor";
            let radioElement: JQuery = $("[class$='" + propertyName + "']").find("label");

            let radioElement2: JQuery = $("[class$='" + propertyName + "']");
            //J-Jewellery       M-Metal      S-Stone
            if (filteritem == 1 || filteritem == undefined) {//For JMS
                let item1 = radioElement[0];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[1];
                let item3 = radioElement[2];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px; font-weight: normal;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;");

            }
            else if (filteritem == 2) {//For JM
                let item1 = radioElement[0];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[1];
                let item3 = radioElement[2];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px; font-weight: normal;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            else if (filteritem == 3) {//For JS
                let item1 = radioElement[0];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[2];
                let item3 = radioElement[1];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px;font-weight: normal;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            else if (filteritem == 4) {//For MS
                let item1 = radioElement[1];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[2];
                let item3 = radioElement[0];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px;font-weight: normal;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            else if (filteritem == 5) {//For J
                let item1 = radioElement[0];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[1];
                let item3 = radioElement[2];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            else if (filteritem == 6) {//For M
                let item1 = radioElement[1];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[0];
                let item3 = radioElement[2];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            else if (filteritem == 7) {//For S
                let item1 = radioElement[2];
                var innerhtml = item1.innerHTML;
                var part1 = innerhtml.substring(0, innerhtml.lastIndexOf('>'));
                var part2 = innerhtml.substring(innerhtml.lastIndexOf('>'), innerhtml.length);
                var newhtml = part1 + ' checked="checked"' + part2;
                item1.innerHTML = newhtml;
                let item2 = radioElement[0];
                let item3 = radioElement[1];
                item1.setAttribute("style", "font-weight: normal;");
                item2.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
                item3.setAttribute("style", "padding-left:50px;font-weight: normal;display: none;");
            }
            return this;
        }
        protected createToolbarExtensions(): void {
            super.createToolbarExtensions()

        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();

            return grid;
        }
        get selectedItems(): Stock.StockItemRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            var request = this.view.params as Serenity.ListRequest;
            var itemtype = request.EqualityFilter.ItemTypeId;
            var studded = request.EqualityFilter.Studded;

            this.view.beginUpdate();

            var self = this;
            let filter = function filter(item, args) {
                var linha = (item as Stock.StockItemRow);

                if (itemtype == undefined) {
                    request.EqualityFilter.ItemTypeId = '101';
                    studded = 1;
                    return true;
                }
                else if (itemtype == "101") {
                    studded = 1;
                    var cols = self.colums;
                    cols = cols.filter(x => x.field != "ItemType");
                    self.slickGrid.setColumns(cols);
                    return true;

                }
                else if (itemtype == "104") {
                    var cols = self.colums;
                    cols = cols.filter(x => x.field != "SKU" && x.field != "LineNo" && x.field != "CategoryName" && x.field != "SubCategoryName" && x.field != "ItemType");
                    self.slickGrid.setColumns(cols);
                    return true;
                }
                else if (itemtype == "105") {
                    var cols = self.colums;
                    cols = cols.filter(x => x.field != "SKU" && x.field != 'TypeName' && x.field != "ItemType");
                    self.slickGrid.setColumns(cols);
                    return true;

                }
                return false;
            }

            this.view.setFilter(filter);

            this.view.endUpdate();
            return true;
        }
    }
     
}